import { Badge, Button, Tabs, TabsList, TabsTrigger } from 'design-system';

import { pluralizeUnit } from '@/shared/lib/format/getAmountLabel';

const catalogTabs = [
  { value: 'spot', label: 'Spot' },
  { value: 'forward-curves', label: 'Forward Curves' }
] as const;

type CatalogHeroProps = {
  count: number;
  newCount: number;
  unit: string;
  activeTab: number;
  onTabChange: () => void;
  onNewClick: () => void;
};

const CatalogHero = ({
  count,
  newCount,
  unit,
  activeTab,
  onTabChange,
  onNewClick
}: CatalogHeroProps) => (
  <div className='flex w-full items-end justify-between'>
    <div className='flex items-center gap-2'>
      <div className='flex items-center gap-1 text-base text-gx-subtext'>
        <span className='font-bold'>{count.toLocaleString('en-US')}</span>
        <span className='font-medium'>{pluralizeUnit(count, unit)}</span>
      </div>
      {newCount > 0 && (
        <Button
          className='h-auto rounded-sm p-0 hover:bg-transparent'
          variant='ghost'
          onClick={onNewClick}
        >
          <Badge variant='new'>{newCount} NEW</Badge>
        </Button>
      )}
    </div>
    <Tabs
      value={catalogTabs[activeTab]?.value ?? catalogTabs[0].value}
      onValueChange={onTabChange}
    >
      <TabsList
        aria-label='Catalog views'
        variant='line'
      >
        {catalogTabs.map(tab => (
          <TabsTrigger
            key={tab.value}
            className='min-w-[200px]'
            value={tab.value}
          >
            {tab.label}
          </TabsTrigger>
        ))}
      </TabsList>
    </Tabs>
  </div>
);

export default CatalogHero;
